module.exports = __webpack_public_path__ + "static/img/10014 (4).df14d8d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10014 (4).webp
// module id = /N1k
// module chunks = 14